/* eslint-disable */

type CookieValue = string | null
type CookieExpiry = number | string | Date | undefined
type CookiePath = string | undefined
type CookieDomain = string | undefined
type CookieSecure = boolean | undefined

interface DocCookies {
  getItem(sKey: string): CookieValue
  setItem(
    sKey: string,
    sValue: string,
    options?: {
      vEnd?: CookieExpiry
      sPath?: CookiePath
      sDomain?: CookieDomain
      bSecure?: CookieSecure
    }
  ): boolean
  removeItem(sKey: string, sPath?: CookiePath, sDomain?: CookieDomain): boolean
  hasItem(sKey: string): boolean
  keys(): string[]
}

export const docCookies: DocCookies = {
  getItem: function (sKey: string): CookieValue {
    if (!sKey) {
      return null
    }
    return (
      decodeURIComponent(
        document.cookie.replace(
          new RegExp(
            '(?:(?:^|.*;)\\s*' +
              encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&') +
              '\\s*\\=\\s*([^;]*).*$)|^.*$'
          ),
          '$1'
        )
      ) || null
    )
  },
  setItem: function (
    sKey: string,
    sValue: string,
    options?: {
      vEnd?: CookieExpiry
      sPath?: CookiePath
      sDomain?: CookieDomain
      bSecure?: CookieSecure
    }
  ): boolean {
    const { vEnd, sPath, sDomain, bSecure } = options || {}
    if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
      return false
    }
    let sExpires = ''
    if (vEnd) {
      switch (vEnd.constructor) {
        case Number:
          sExpires =
            vEnd === Infinity
              ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT'
              : '; max-age=' + vEnd
          break
        case String:
          sExpires = '; expires=' + vEnd
          break
        case Date:
          sExpires = '; expires=' + (vEnd as Date).toUTCString()
          break
      }
    }
    document.cookie =
      encodeURIComponent(sKey) +
      '=' +
      encodeURIComponent(sValue) +
      sExpires +
      (sDomain ? '; domain=' + sDomain : '') +
      ('; path=' + (sPath ? sPath : '/')) +
      (bSecure ? '; secure' : '')
    return true
  },
  removeItem: function (
    sKey: string,
    sPath?: CookiePath,
    sDomain?: CookieDomain
  ): boolean {
    if (!this.hasItem(sKey)) {
      return false
    }
    document.cookie =
      encodeURIComponent(sKey) +
      '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' +
      (sDomain ? '; domain=' + sDomain : '') +
      ('; path=' + (sPath ? sPath : '/'))
    return true
  },
  hasItem: function (sKey: string): boolean {
    if (!sKey) {
      return false
    }
    return new RegExp(
      '(?:^|;\\s*)' +
        encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&') +
        '\\s*\\='
    ).test(document.cookie)
  },
  keys: function (): string[] {
    let aKeys = document.cookie
      .replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, '')
      .split(/\s*(?:\=[^;]*)?;\s*/)
    for (let nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) {
      aKeys[nIdx] = decodeURIComponent(aKeys[nIdx])
    }
    return aKeys
  }
}
